import { Tooltip } from 'antd';
import { useState } from 'react';

import CopyIconSVG from '../../assets/CopyIconSVG';
import TickIconSVG from '../../assets/TickIconSVG';

const CopyButton = ({ onCopy = () => false }) => {
  const [showCopiedIcon, setShowCopiedIcon] = useState(false);

  return (
    <Tooltip placement='bottom' title='Copy' arrow>
      <span
        onClick={async () => {
          const copySuccess = await onCopy();
          if (copySuccess) {
            setShowCopiedIcon(true);
            setTimeout(() => {
              setShowCopiedIcon(false);
            }, 1500);
          }
        }}
      >
        <div className={`action-icon copy-icon ${(showCopiedIcon && 'copied') || ''}`}>
          {showCopiedIcon ? <TickIconSVG /> : <CopyIconSVG />}
        </div>
      </span>
    </Tooltip>
  );
};

export default CopyButton;
